module.exports = __webpack_public_path__ + "img/icon-settings-fuente.174863b3.svg";